/**
 * Pont d'action entre le panel network (vanilla JS, via PluginPanelHost) et les
 * panels SolidJS (RDP, LAN Browser, SMB, SSH, fichiers). Le scanner de services (vue `scan`) y dépose
 * une cible (IP + port) et navigue vers le panel dédié ; le panel consommateur
 * lit puis vide la cible au montage.
 *
 * Ce sont des signals module-level (pas de context) — volontairement simple pour
 * un flux à usage unique : 1 producteur (network-scan) → 1 consommateur (rdp/web).
 */
import { createSignal } from "solid-js";

export interface RdpTarget {
  host: string;
  port?: number;
}

export interface WebTarget {
  host: string;
  port?: number;
  url: string;
}

/** Cible RDP en attente de consommation par le panel RDP. */
export const [pendingRdpTarget, setPendingRdpTarget] = createSignal<RdpTarget | null>(null);

/** Cible Web (URL) en attente de consommation par le panel LAN Browser. */
export const [pendingWebTarget, setPendingWebTarget] = createSignal<WebTarget | null>(null);

/** Type d'action émis par le panel network vanilla. */
export type NetworkActionType = "rdp" | "web" | "smb" | "files" | "ssh";

/** Charge utile d'une action émise par le panel network vanilla. */
export interface NetworkActionPayload {
  host: string;
  port?: number;
  url?: string;
}

// ── Navigation partagée ──────────────────────────────────────────────────
// Les panels enregistrés (registerPanel) ne reçoivent pas de props d'App, donc
// pas accès à `activate()`. On expose un handler de navigation module-level,
// branché une fois par App au bootstrap. Convention d'id : "panel:<id>".
let activateHandler: ((id: string) => void) | null = null;

/** App branche ici son `activate(id)` au bootstrap. */
export function setActivateHandler(fn: (id: string) => void): void {
  activateHandler = fn;
}

/** Active un panel par son id de section (ex: "panel:rdp"). No-op si non branché. */
export function activatePanel(id: string): void {
  activateHandler?.(id);
}
